import { MutableRefObject, useEffect, useRef, useState } from 'react'

export const useOverflowElementsMeta = (
  active: boolean
): {
  overflowElementIndex: number
  overflowElementsCount: number
  valuesInnerContainer: MutableRefObject<HTMLDivElement>
} => {
  const valuesInnerContainer = useRef<HTMLDivElement>()
  const [overflowElementsMeta, setOverflowElementsMeta] = useState<{
    overflowElementIndex: number
    overflowElementsCount: number
  }>({ overflowElementIndex: undefined, overflowElementsCount: undefined })

  useEffect(() => {
    const onResize = () => {
      setOverflowElementsMeta({
        overflowElementIndex: undefined,
        overflowElementsCount: undefined
      })
      calcAndApplyOverflowMeta()
    }
    const calcAndApplyOverflowMeta = () => {
      if (!active) {
        setOverflowElementsMeta({
          overflowElementIndex: undefined,
          overflowElementsCount: undefined
        })
        window.removeEventListener('resize', onResize, false)
        return
      }
      if (!valuesInnerContainer.current) return

      window.addEventListener('resize', onResize, false)

      const {
        clientHeight,
        scrollHeight,
        childNodes,
        childElementCount
      } = valuesInnerContainer.current

      const hasOverflowElements = clientHeight * 2 < scrollHeight
      if (!hasOverflowElements) return

      const indexOfFirstElementOnSecondLine = Array.from(childNodes).findIndex(
        (node: any) => node.offsetTop > clientHeight
      )
      const overflowElementIndex = Math.max(
        0,
        indexOfFirstElementOnSecondLine - 1
      )

      setOverflowElementsMeta({
        overflowElementIndex,
        overflowElementsCount:
          childElementCount - indexOfFirstElementOnSecondLine + 1
      })
    }

    calcAndApplyOverflowMeta()

    return () =>
      window.removeEventListener('resize', onResize, false)
  }, [
    valuesInnerContainer,
    valuesInnerContainer.current?.scrollHeight,
    valuesInnerContainer.current?.childElementCount,
    active
  ])

  return {
    valuesInnerContainer,
    ...overflowElementsMeta
  }
}
